module.exports = __webpack_public_path__ + "images/ico-contents-act.svg?2ce89ef0f8079f83ecb300e4f86b4492";